////////LIBRARY/////////
import React, { Fragment } from 'react'
import styled from 'styled-components'
import { get, map, isNull, isEmpty } from 'lodash'
///////COMPONENTS///////
import TableRows from '../TableRows'
import IsVisible from '../IsVisible'
import IsAction from '../IsAction'

//////STYLED//////
const BodyCells = styled.td`
	text-align: center;
	background-color: inherit;
	height: 50px;
	box-sizing: border-box;
	padding: 10px;
	border-right: ${(props) => (props.titleColumnCampaign === true ? '1px solid #F1F1F3' : 'none')};
	border-top: 1px solid ${(props) => props.theme.colors.table.borderTable};
`
const CellsCampaign = styled(BodyCells)`
	border: 1px solid ${(props) => props.theme.colors.table.borderTable};
`
const BodyCellsSticky = styled(BodyCells)`
	position: sticky;
	background-color: ${(props) => props.theme.colors.white};
	right: 0;
	z-index: ${(props) => (props.toggledAction ? 50 : 1)};
	border-left: 1px solid ${(props) => props.theme.colors.table.borderTable};
`
const Separator = styled.div`
	display: flex;
	width: 100%;
	background-color: #f1f1f1;
	height: 20px;
`
//////STYLED//////

const CellsSticky = ({ row, column, children, indexRow, dataSize, ...rest }) => {
	return (
		<BodyCellsSticky>
			<column.component row={row} column={column} indexRow={indexRow} dataSize={dataSize} {...rest} />
		</BodyCellsSticky>
	)
}

const CellsCampaignAction = (props) => {
	let checkifRowNull = get(props.row, props.column.dataHook, '-')
	checkifRowNull = !isNull(checkifRowNull) && !isEmpty(checkifRowNull) ? checkifRowNull : '-'
	return (
		<CellsCampaign rowSpan="2">
			{props.renderProps ? <props.renderProps row={props.row} column={props.column} /> : checkifRowNull.toString()}
		</CellsCampaign>
	)
}

const Cells = (props) => {
	let checkifRowNull = get(props.row, props.column.dataHook, '-')
	checkifRowNull = !isNull(checkifRowNull) && !isEmpty(checkifRowNull) ? checkifRowNull : '-'
	return (
		<BodyCells titleColumnCampaign={props.column.titleColumnCampaign || false}>
			{props.renderProps ? <props.renderProps row={props.row} column={props.column} /> : checkifRowNull.toString()}
		</BodyCells>
	)
}

const TableCampaignRows = (props) => {
	return (
		<Fragment>
			<TableRows key={props.id}>
				{map(props.columns, (column, id) => (
					<IsVisible key={id} isVisible={column.visibility}>
						<IsAction
							isAction={column.action || false}
							data={{ row: props.row, column: column }}
							actionCell={(data) => (
								<CellsCampaignAction
									row={data.row}
									column={data.column}
									indexRow={props.indexRow}
									dataSize={props.dataSize}
									renderProps={column.component}
									{...column.rest}
								/>
							)}
							normalCell={(data) => <Cells row={data.row} column={data.column} renderProps={column.component} />}
						/>
					</IsVisible>
				))}
			</TableRows>
			<TableRows key={`${props.id}-${props.id + 1}`} marginCampaign>
				{props.campaignValues && (
					<props.campaignValues.campaignComponent row={props.row} column={props.columns} getValues={props.getValues} />
				)}
			</TableRows>
			<Separator />
		</Fragment>
	)
}

TableCampaignRows.propTypes = {}

TableCampaignRows.defaultPropTypes = {}

export default TableCampaignRows
